(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-design-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('new-design-hero')) {
    customElements.define(
      'new-design-hero',
      class NewDesignHero extends HTMLElement {
        connectedCallback() {
          this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.desktopQuery = window.matchMedia('(min-width: 700px)');
          this.syncMediaPlayback = this.syncMediaPlayback.bind(this);

          this.addMediaQueryListener(this.reducedMotionQuery);
          this.addMediaQueryListener(this.desktopQuery);
          requestAnimationFrame(this.syncMediaPlayback);
        }

        disconnectedCallback() {
          this.removeMediaQueryListener(this.reducedMotionQuery);
          this.removeMediaQueryListener(this.desktopQuery);
        }

        addMediaQueryListener(query) {
          if (query.addEventListener) {
            query.addEventListener('change', this.syncMediaPlayback);
          } else {
            query.addListener(this.syncMediaPlayback);
          }
        }

        removeMediaQueryListener(query) {
          if (!query) return;

          if (query.removeEventListener) {
            query.removeEventListener('change', this.syncMediaPlayback);
          } else {
            query.removeListener(this.syncMediaPlayback);
          }
        }

        syncMediaPlayback() {
          this.querySelectorAll('video').forEach((video) => {
            const mediaElement = video.closest('video-media');
            const shouldPause = this.reducedMotionQuery.matches || getComputedStyle(mediaElement).display === 'none';

            if (shouldPause) {
              video.pause();
            } else {
              video.play().catch(() => {});
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-multi-column"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('count-up-statistics')) {
    customElements.define(
      'count-up-statistics',
      class CountUpStatistics extends HTMLElement {
        connectedCallback() {
          if (this.isInitialized) return;

          this.isInitialized = true;
          this.animationFrame = null;
          this.observer = null;
          this.hasAnimated = false;
          this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.handleReducedMotionChange = this.handleReducedMotionChange.bind(this);
          this.counters = Array.from(this.querySelectorAll('[data-count-up-value]'))
            .map((element) => this.parseCounter(element))
            .filter(Boolean);

          if (this.counters.length === 0) return;

          this.addReducedMotionListener();

          if (this.reducedMotionQuery.matches || !('IntersectionObserver' in window)) {
            this.finishAnimation();
            return;
          }

          this.counters.forEach((counter) => {
            counter.element.textContent = counter.format(0);
          });

          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35)) return;

              this.observer.disconnect();
              this.observer = null;
              this.startAnimation();
            },
            { threshold: 0.35 }
          );

          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.animationFrame !== null) {
            cancelAnimationFrame(this.animationFrame);
            this.animationFrame = null;
          }

          if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
          }

          this.removeReducedMotionListener();
          this.restoreFinalValues();
          this.isInitialized = false;
        }

        parseCounter(element) {
          const source = element.dataset.countUpValue.trim();
          const numberMatch = source.match(/\d+(?:[.,]\d+)*/);

          if (!numberMatch) return null;

          const token = numberMatch[0];
          const groupedNumberMatch = token.match(/^\d{1,3}([.,])\d{3}(?:\1\d{3})*$/);
          const isInteger = /^\d+$/.test(token);

          if (!groupedNumberMatch && !isInteger) return null;

          const groupSeparator = groupedNumberMatch ? groupedNumberMatch[1] : '';
          const target = Number.parseInt(token.replace(/\D/g, ''), 10);

          if (!Number.isFinite(target)) return null;

          const prefix = source.slice(0, numberMatch.index);
          const suffix = source.slice(numberMatch.index + token.length);
          const originalMarkup = element.innerHTML;

          return {
            element,
            originalMarkup,
            target,
            format(value) {
              let digits = String(Math.max(0, Math.round(value)));

              if (groupSeparator) {
                digits = digits.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
              }

              return `${prefix}${digits}${suffix}`;
            },
          };
        }

        startAnimation() {
          if (this.hasAnimated || this.reducedMotionQuery.matches) {
            this.finishAnimation();
            return;
          }

          this.hasAnimated = true;
          const duration = 1400;
          const startTime = performance.now();

          const update = (currentTime) => {
            const progress = Math.min((currentTime - startTime) / duration, 1);
            const easedProgress = 1 - Math.pow(1 - progress, 3);

            this.counters.forEach((counter) => {
              counter.element.textContent = counter.format(counter.target * easedProgress);
            });

            if (progress < 1) {
              this.animationFrame = requestAnimationFrame(update);
            } else {
              this.animationFrame = null;
              this.restoreFinalValues();
            }
          };

          this.animationFrame = requestAnimationFrame(update);
        }

        finishAnimation() {
          this.hasAnimated = true;

          if (this.animationFrame !== null) {
            cancelAnimationFrame(this.animationFrame);
            this.animationFrame = null;
          }

          if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
          }

          this.restoreFinalValues();
        }

        restoreFinalValues() {
          this.counters?.forEach((counter) => {
            counter.element.innerHTML = counter.originalMarkup;
          });
        }

        handleReducedMotionChange(event) {
          if (event.matches) this.finishAnimation();
        }

        addReducedMotionListener() {
          if (this.reducedMotionQuery.addEventListener) {
            this.reducedMotionQuery.addEventListener('change', this.handleReducedMotionChange);
          } else {
            this.reducedMotionQuery.addListener(this.handleReducedMotionChange);
          }
        }

        removeReducedMotionListener() {
          if (!this.reducedMotionQuery || !this.handleReducedMotionChange) return;

          if (this.reducedMotionQuery.removeEventListener) {
            this.reducedMotionQuery.removeEventListener('change', this.handleReducedMotionChange);
          } else {
            this.reducedMotionQuery.removeListener(this.handleReducedMotionChange);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scheduled-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scheduled-hero')) {
    customElements.define(
      'scheduled-hero',
      class ScheduledHero extends HTMLElement {
        connectedCallback() {
          this.cards = Array.from(this.querySelectorAll('[data-scheduled-hero-card]'));
          this.designMode = this.hasAttribute('data-design-mode');
          this.requestedTimeZone = this.dataset.timezone || 'Europe/Berlin';
          this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.desktopQuery = window.matchMedia('(min-width: 700px)');
          this.maximumTimeout = 2147483647;
          this.activeCard = null;
          this.editorCard = null;
          this.timer = null;
          const sectionElement = this.closest('.shopify-section');
          this.precedingQuickMenu = sectionElement?.previousElementSibling?.querySelector('.mobile-quick-menu') || null;
          this.precedingQuickMenuWasTransparent = this.precedingQuickMenu?.hasAttribute('allow-transparent-header') || false;

          this.resolveSchedule = this.resolveSchedule.bind(this);
          this.syncMediaPlayback = this.syncMediaPlayback.bind(this);
          this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);
          this.handleBlockDeselect = this.handleBlockDeselect.bind(this);

          this.wallTimeFormatter = this.createWallTimeFormatter(this.requestedTimeZone);
          this.addMediaQueryListener(this.reducedMotionQuery);
          this.addMediaQueryListener(this.desktopQuery);
          document.addEventListener('visibilitychange', this.handleVisibilityChange);

          if (this.designMode) {
            document.addEventListener('shopify:block:select', this.handleBlockSelect);
            document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
          }

          this.resolveSchedule();
        }

        disconnectedCallback() {
          this.clearTimer();
          this.removeMediaQueryListener(this.reducedMotionQuery);
          this.removeMediaQueryListener(this.desktopQuery);
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
          this.precedingQuickMenu?.toggleAttribute('allow-transparent-header', this.precedingQuickMenuWasTransparent);
        }

        createWallTimeFormatter(timeZone) {
          const options = {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          };

          try {
            return new Intl.DateTimeFormat('en-US', options);
          } catch (error) {
            console.warn(`Scheduled hero: invalid timezone "${timeZone}". Falling back to Europe/Berlin.`, error);
            options.timeZone = 'Europe/Berlin';
            return new Intl.DateTimeFormat('en-US', options);
          }
        }

        timezoneOffsetAt(utc) {
          const parts = {};

          this.wallTimeFormatter.formatToParts(new Date(utc)).forEach((part) => {
            parts[part.type] = part.value;
          });

          const hour = Number(parts.hour) === 24 ? 0 : Number(parts.hour);

          return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), hour, Number(parts.minute), Number(parts.second)) - utc;
        }

        parseWallTime(value) {
          const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);

          if (!match) return null;

          const year = Number(match[1]);
          const month = Number(match[2]);
          const day = Number(match[3]);
          const hour = Number(match[4]);
          const minute = Number(match[5]);
          const second = Number(match[6] || 0);
          const wallAsUtc = Date.UTC(year, month - 1, day, hour, minute, second);
          const normalized = new Date(wallAsUtc);

          if (
            normalized.getUTCFullYear() !== year ||
            normalized.getUTCMonth() !== month - 1 ||
            normalized.getUTCDate() !== day ||
            normalized.getUTCHours() !== hour ||
            normalized.getUTCMinutes() !== minute ||
            normalized.getUTCSeconds() !== second
          ) {
            return null;
          }

          let utc = wallAsUtc - this.timezoneOffsetAt(wallAsUtc);
          utc = wallAsUtc - this.timezoneOffsetAt(utc);

          return utc;
        }

        getSchedule(card) {
          const rawStart = card.dataset.scheduleStart?.trim() || '';
          const rawEnd = card.dataset.scheduleEnd?.trim() || '';

          if (!rawStart && !rawEnd) {
            return { isDefault: true, isValid: true, start: null, end: null };
          }

          const start = rawStart ? this.parseWallTime(rawStart) : null;
          const end = rawEnd ? this.parseWallTime(rawEnd) : null;
          const isValid = (rawStart === '' || start !== null) && (rawEnd === '' || end !== null) && !(start !== null && end !== null && end <= start);

          if (!isValid && card.dataset.scheduleWarningShown !== 'true') {
            card.dataset.scheduleWarningShown = 'true';
            console.warn('Scheduled hero: ignoring a card with an invalid schedule.', card);
          }

          return { isDefault: false, isValid, start, end };
        }

        resolveSchedule() {
          if (this.editorCard) return;

          const now = Date.now();
          const futureBoundaries = [];
          let scheduledWinner = null;
          let defaultCard = null;

          for (const card of this.cards) {
            const schedule = this.getSchedule(card);

            if (!schedule.isValid) continue;

            if (schedule.isDefault) {
              defaultCard ||= card;
              continue;
            }

            if (schedule.start !== null && schedule.start > now) futureBoundaries.push(schedule.start);
            if (schedule.end !== null && schedule.end > now) futureBoundaries.push(schedule.end);

            if (scheduledWinner === null && (schedule.start === null || now >= schedule.start) && (schedule.end === null || now < schedule.end)) {
              scheduledWinner = card;
            }
          }

          this.setActiveCard(scheduledWinner || defaultCard);
          this.scheduleNextResolution(now, futureBoundaries);
        }

        scheduleNextResolution(now, boundaries) {
          this.clearTimer();

          if (boundaries.length === 0) return;

          const nextBoundary = Math.min(...boundaries);
          const delay = Math.min(Math.max(nextBoundary - now + 50, 50), this.maximumTimeout);
          this.timer = window.setTimeout(this.resolveSchedule, delay);
        }

        setActiveCard(card) {
          const cardChanged = this.activeCard !== card;
          this.activeCard = card;
          this.hidden = card === null;

          for (const candidate of this.cards) {
            const isActive = candidate === card;
            candidate.hidden = !isActive;
            candidate.setAttribute('aria-hidden', String(!isActive));
            candidate.toggleAttribute('allow-transparent-header', isActive && candidate.dataset.allowTransparentHeader === 'true');

            if (!isActive) candidate.classList.remove('is-activating');
          }

          if (cardChanged && card) {
            card.classList.remove('is-activating');
            void card.offsetWidth;
            card.classList.add('is-activating');
          }

          this.syncTransparentHeader(card);
          requestAnimationFrame(this.syncMediaPlayback);
        }

        syncTransparentHeader(card) {
          const wantsTransparentHeader = card?.dataset.allowTransparentHeader === 'true';

          this.precedingQuickMenu?.toggleAttribute('allow-transparent-header', wantsTransparentHeader);
        }

        syncMediaPlayback() {
          for (const card of this.cards) {
            for (const video of card.querySelectorAll('video')) {
              const mediaElement = video.closest('video-media');
              const visibleMedia = mediaElement || video;
              const shouldPlay = card === this.activeCard && !this.reducedMotionQuery.matches && getComputedStyle(visibleMedia).display !== 'none';

              if (shouldPlay) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            }
          }
        }

        handleVisibilityChange() {
          if (document.visibilityState === 'visible') {
            this.resolveSchedule();
            this.syncMediaPlayback();
          } else {
            this.cards.forEach((card) => card.querySelectorAll('video').forEach((video) => video.pause()));
          }
        }

        handleBlockSelect(event) {
          const selectedCard = event.target instanceof Element ? event.target.closest('[data-scheduled-hero-card]') : null;

          if (!selectedCard || !this.contains(selectedCard)) return;

          this.editorCard = selectedCard;
          this.clearTimer();
          this.setActiveCard(selectedCard);
        }

        handleBlockDeselect(event) {
          const deselectedCard = event.target instanceof Element ? event.target.closest('[data-scheduled-hero-card]') : null;

          if (!this.editorCard || (deselectedCard && deselectedCard !== this.editorCard)) return;

          this.editorCard = null;
          this.resolveSchedule();
        }

        addMediaQueryListener(query) {
          if (query.addEventListener) {
            query.addEventListener('change', this.syncMediaPlayback);
          } else {
            query.addListener(this.syncMediaPlayback);
          }
        }

        removeMediaQueryListener(query) {
          if (!query) return;

          if (query.removeEventListener) {
            query.removeEventListener('change', this.syncMediaPlayback);
          } else {
            query.removeListener(this.syncMediaPlayback);
          }
        }

        clearTimer() {
          if (this.timer !== null) {
            window.clearTimeout(this.timer);
            this.timer = null;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
